function veda_fn_829275dfc74c4daf9a9bfbf08d8606df () {
      
  if (window.veda_fn_829275dfc74c4daf9a9bfbf08d8606dfCleanup === undefined) {
    window.veda_fn_829275dfc74c4daf9a9bfbf08d8606dfCleanup = {
      listeners: [],
      push(listener) {
        this.listeners.push(listener);
      },
      cleanup() {
        this.listeners.forEach(listener => listener());
        this.listeners = [];
      }
    }
  }
  window.veda_fn_829275dfc74c4daf9a9bfbf08d8606dfCleanup.cleanup();

      try {
        const uniqueId = "id_27ef38fb-f994-4d3b-bc3e-ddc08c600069";
        const containers = document.querySelectorAll(`[data-id="${uniqueId}"]`);
        containers.forEach(container => {
          if (!container) {
            return;
          }
          veda.plugins.videoCover(container);
          const { store } = veda.utils;
const { productWishList, cart } = veda.plugins;
const linkEls = container.querySelectorAll(".link-js");

function handleBodyHeightCalc() {
  const { display } = window.getComputedStyle(container);
  const height = container.offsetHeight;
  if (display === "none") {
    document.body.style.removeProperty("padding-bottom");
  } else {
    document.body.style.paddingBottom = `${height}px`;
  }
}
handleBodyHeightCalc();
window.addEventListener("scroll", handleBodyHeightCalc);

function renderWishlistCount() {
  linkEls.forEach((el) => {
    if (el.href.includes("wishlist")) {
      const badgeEl = el.querySelector(".badge-js");
      const count = productWishList.getData()?.length ?? "";
      badgeEl.textContent = count;
    }
  });
}

function renderCartCount() {
  linkEls.forEach((el) => {
    const cartDrawerVeda = document.querySelector(".mini-cart-js");
    if (el.classList.contains("veda-cart-toggle-auto-js") && !cartDrawerVeda) {
      const badgeEl = el.querySelector(".badge-js");
      const count = cart.getData()?.item_count ?? "";
      badgeEl.textContent = count;
    }
  });
}

function handleShow() {
  const isMobile = document.body.classList.contains("mobile");
  if (isMobile || window.innerWidth < 768) {
    container.style.display = "block";
  } else {
    container.style.removeProperty("display");
  }
}

const unsub = productWishList.subscribe(renderWishlistCount);
const unsub2 = cart.subscribe(renderCartCount);

handleShow();
const observer = new MutationObserver(handleShow);
window.addEventListener("resize", handleShow);

observer.observe(document.body, {
  attributes: true,
  attributeFilter: ["class"],
});

function handleActive() {
  if (!builderMode) {
    linkEls.forEach((el) => {
      let url = new URL("");
      if (el.classList.contains("veda-cart-toggle-auto-js")) {
        url = new URL(el.href || el.getAttribute("data-path") || "/cart");
      } else {
        url = new URL(el.href);
      }
      const { root } = window.Shopify.routes;
      const pathname = url.pathname.includes(root)
        ? url.pathname
        : `${root}${url.pathname}`.replace(/\/\//g, "/");
      if (
        pathname.replace(/\/$/g, "") ===
        window.location.pathname.replace(/\/$/g, "")
      ) {
        const colorEls = el.querySelectorAll(".color-js");
        colorEls.forEach((colorEl) => {
          colorEl.style.color = "var(--color-primary)";
        });
      }
    });
  }
}
handleActive();

window.veda_fn_829275dfc74c4daf9a9bfbf08d8606dfCleanup.push(() => {
  unsub();
  unsub2();
  observer.disconnect();
  window.removeEventListener("resize", handleShow);
  window.removeEventListener("scroll", handleBodyHeightCalc);
});
        });
      } catch(error) {
        console.error(error);
      }
    }
veda_fn_829275dfc74c4daf9a9bfbf08d8606df();
function veda_fn_cfe2865823534680b0368d75585a99ee () {
      
  if (window.veda_fn_cfe2865823534680b0368d75585a99eeCleanup === undefined) {
    window.veda_fn_cfe2865823534680b0368d75585a99eeCleanup = {
      listeners: [],
      push(listener) {
        this.listeners.push(listener);
      },
      cleanup() {
        this.listeners.forEach(listener => listener());
        this.listeners = [];
      }
    }
  }
  window.veda_fn_cfe2865823534680b0368d75585a99eeCleanup.cleanup();

      try {
        const uniqueId = "id_a00ea6aa-bfd8-4aaf-ae70-043739286c81";
        const containers = document.querySelectorAll(`[data-id="${uniqueId}"]`);
        containers.forEach(container => {
          if (!container) {
            return;
          }
          veda.plugins.videoCover(container);
          function setBackground() {
  const separatorEl = container.querySelector(".separator-js");
  const sectionEls = Array.from(document.querySelectorAll('[data-id^="id_"]'));
  const currentSectionIndex = sectionEls.findIndex((el) => el === container);
  const prevSectionEl = sectionEls[currentSectionIndex - 1];
  if (prevSectionEl) {
    const { backgroundColor } = window.getComputedStyle(prevSectionEl);
    separatorEl.style.backgroundColor = backgroundColor;
  }
}
setBackground();

if (builderMode) {
  const observer = new MutationObserver(() => {
    setBackground();
  });
  observer.observe(document.querySelector("#veda-root"), {
    childList: true,
    attributes: true,
  });
  window.veda_fn_cfe2865823534680b0368d75585a99eeCleanup.push(() => {
    observer.disconnect();
  });
}
        });
      } catch(error) {
        console.error(error);
      }
    }
veda_fn_cfe2865823534680b0368d75585a99ee();
function veda_fn_e1609bc2226946a898d82977a6189a07 () {
      
  if (window.veda_fn_e1609bc2226946a898d82977a6189a07Cleanup === undefined) {
    window.veda_fn_e1609bc2226946a898d82977a6189a07Cleanup = {
      listeners: [],
      push(listener) {
        this.listeners.push(listener);
      },
      cleanup() {
        this.listeners.forEach(listener => listener());
        this.listeners = [];
      }
    }
  }
  window.veda_fn_e1609bc2226946a898d82977a6189a07Cleanup.cleanup();

      try {
        const uniqueId = "id_190dca1f-1e13-40ea-93b1-71a86982485e";
        const containers = document.querySelectorAll(`[data-id="${uniqueId}"]`);
        containers.forEach(container => {
          if (!container) {
            return;
          }
          veda.plugins.videoCover(container);
          const { countdown, textfit } = veda.plugins;
const countdownEls = container.querySelectorAll(".veda-countdown");
const videoButtonEls = container.querySelectorAll(".veda-video-button-js");
const videosEl = document.querySelector(`.veda-videos-${uniqueId}-js`);
const videoEls = videosEl.querySelectorAll(".veda-video-js");
const videoCloseEls = videosEl.querySelectorAll(
  ".veda-video-close-js, .veda-video-overlay-js"
);

countdownEls.forEach((countdownEl) => {
  const destroy = countdown(countdownEl);
  window.veda_fn_e1609bc2226946a898d82977a6189a07Cleanup.push(() => {
    destroy();
  });
});

function handleTransformableTextFit() {
  const fitTextEls = container.querySelectorAll(
    ".veda-transformable > .veda-textfit"
  );
  fitTextEls.forEach((el) => {
    textfit(el, { min: 5, max: 300 });
  });
}

function handleCountdownTextFit() {
  countdownEls.forEach((countdownEl) => {
    const countdownTextFitEls = countdownEl.querySelectorAll(".veda-textfit");

    countdownTextFitEls.forEach((el) => {
      textfit(el, {
        min: 5,
        max: 300,
      });
    });
  });
}

function init() {
  handleTransformableTextFit();
  handleCountdownTextFit();
}

if (builderMode) {
  init();
} else {
  if (/comp|inter/.test(document.readyState)) {
    init();
  } else {
    window.addEventListener("DOMContentLoaded", init);
  }
}
window.addEventListener("resize", init);

countdownEls.forEach((countdownEl) => {
  const mutationObserver = new MutationObserver(() => {
    handleCountdownTextFit();
  });
  mutationObserver.observe(countdownEl.parentElement, { attributes: true });
  window.veda_fn_e1609bc2226946a898d82977a6189a07Cleanup.push(() => {
    mutationObserver.disconnect();
  });
});

window.veda_fn_e1609bc2226946a898d82977a6189a07Cleanup.push(() => {
  window.removeEventListener("DOMContentLoaded", init);
  window.removeEventListener("resize", init);
});

videoButtonEls.forEach((videoButtonEl) => {
  function handleClick() {
    const id = videoButtonEl.getAttribute("data-button-video-id");
    const videoEl = videosEl.querySelector(`[data-video-id="${id}"`);
    if (videoEl) {
      const videoContentEl = videoEl.querySelector(".veda-video-content-js");
      const embedEl = videoEl.querySelector(".veda-embed-js");
      const src = embedEl.getAttribute("data-src");
      embedEl.innerHTML = `<iframe src="${src}" frameborder="0"></iframe>`;
      videoEl.style.visibility = "visible";
      videoContentEl.style.opacity = 1;
      videoContentEl.style.transform = "scale(1)";
    }
  }
  videoButtonEl.addEventListener("click", handleClick);
  window.veda_fn_e1609bc2226946a898d82977a6189a07Cleanup.push(() => {
    videoButtonEl.removeEventListener("click", handleClick);
  });
});

videoCloseEls.forEach((videoCloseEl) => {
  function handleClose() {
    const videoEl = videoCloseEl.closest(".veda-video-js");
    const videoContentEl = videoEl.querySelector(".veda-video-content-js");
    const embedEl = videoEl.querySelector(".veda-embed-js");
    videoEl.style.removeProperty("visibility");
    videoContentEl.style.removeProperty("opacity");
    videoContentEl.style.removeProperty("transform");
    embedEl.innerHTML = "";
  }

  videoCloseEl.addEventListener("click", handleClose);

  window.veda_fn_e1609bc2226946a898d82977a6189a07Cleanup.push(() => {
    videoCloseEl.removeEventListener("click", handleClose);
  });
});
if (!builderMode) {
  window.addEventListener("load", init);
}
        });
      } catch(error) {
        console.error(error);
      }
    }
veda_fn_e1609bc2226946a898d82977a6189a07();
function veda_fn_6352a56d981a4ccb92aa99d705c14737 () {
      
  if (window.veda_fn_6352a56d981a4ccb92aa99d705c14737Cleanup === undefined) {
    window.veda_fn_6352a56d981a4ccb92aa99d705c14737Cleanup = {
      listeners: [],
      push(listener) {
        this.listeners.push(listener);
      },
      cleanup() {
        this.listeners.forEach(listener => listener());
        this.listeners = [];
      }
    }
  }
  window.veda_fn_6352a56d981a4ccb92aa99d705c14737Cleanup.cleanup();

      try {
        const uniqueId = "id_8c8656b2-a882-4885-b48e-026cb9b78ec8";
        const containers = document.querySelectorAll(`[data-id="${uniqueId}"]`);
        containers.forEach(container => {
          if (!container) {
            return;
          }
          veda.plugins.videoCover(container);
          
        });
      } catch(error) {
        console.error(error);
      }
    }
veda_fn_6352a56d981a4ccb92aa99d705c14737();